import React from 'react';
import classnames from 'classnames';
import { translate } from 'react-i18next';

import { ASSETS_EDIT_SECTIONS } from 'components/assets/constants';

const AssetsEditNavBar = ({ handleSectionChange, t, section, asset }) => {
  const handleClick = (e) => {
    e.preventDefault();
    handleSectionChange(e.target.href.split('#').pop());
  };

  const isActive = (currentSection) => {
    return currentSection === section;
  };

  return (
    <ul className="nav nav-tabs nav-fill justify-content-center">
      <li className="nav-item">
        <a
          className={classnames('nav-link', {
            active: isActive(ASSETS_EDIT_SECTIONS.FORM),
          })}
          href={`#${ASSETS_EDIT_SECTIONS.FORM}`}
          onClick={handleClick}
        >
          {t('assets.section.form')}
        </a>
      </li>

      {asset && asset._status && asset._status.key === 'DEPRECIATING' && (
        <li className="nav-item">
          <a
            className={classnames('nav-link', {
              active: isActive(ASSETS_EDIT_SECTIONS.DEPRECIATION),
            })}
            href={`#${ASSETS_EDIT_SECTIONS.DEPRECIATION}`}
            onClick={handleClick}
          >
            {t('assets.section.depreciation')}
          </a>
        </li>
      )}
      <li className="nav-item">
        <a
          className={classnames('nav-link', {
            active: isActive(ASSETS_EDIT_SECTIONS.FILES),
          })}
          href={`#${ASSETS_EDIT_SECTIONS.FILES}`}
          onClick={handleClick}
        >
          {t('assets.section.files')}
        </a>
      </li>
      <li className="nav-item">
        <a
          className={classnames('nav-link', {
            active: isActive(ASSETS_EDIT_SECTIONS.NOTES),
          })}
          href={`#${ASSETS_EDIT_SECTIONS.NOTES}`}
          onClick={handleClick}
        >
          {t('assets.section.notes')}
        </a>
      </li>
      <li className="nav-item">
        <a
          className={classnames('nav-link', {
            active: isActive(ASSETS_EDIT_SECTIONS.HISTORICS),
          })}
          href={`#${ASSETS_EDIT_SECTIONS.HISTORICS}`}
          onClick={handleClick}
        >
          {t('assets.section.historic')}
        </a>
      </li>
      <li className="nav-item">
        <a
          className={classnames('nav-link', {
            active: isActive(ASSETS_EDIT_SECTIONS.BILL),
          })}
          href={`#${ASSETS_EDIT_SECTIONS.BILL}`}
          onClick={handleClick}
        >
          {t('assets.section.bills')}
        </a>
      </li>
      <li className="nav-item">
        <a
          className={classnames('nav-link', {
            active: isActive(ASSETS_EDIT_SECTIONS.CUSTOMSDOCUMENTS),
          })}
          href={`#${ASSETS_EDIT_SECTIONS.CUSTOMSDOCUMENTS}`}
          onClick={handleClick}
        >
          {t('assets.section.customs_documents')}
        </a>
      </li>
    </ul>
  );
};

export default translate()(AssetsEditNavBar);



// WEBPACK FOOTER //
// src/components/assets/edit/AssetsEditNavBar.js